<div class="px-2">
    <span [ngClass]="getClasses()"></span>
</div>
